// extracted by mini-css-extract-plugin
module.exports = {"root":"Node_root__OW7qv","row":"Node_row__37MWw","label":"Node_label__4MB1b","footer":"Node_footer__9nFic"};